import React from 'react';
import { Stack, Typography } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import { ERROR_ICON_COLOR } from './styles';

export const errorOutlinedInputSx = {
  '& fieldset': { borderColor: ERROR_ICON_COLOR },
  '&:hover fieldset': { borderColor: ERROR_ICON_COLOR },
  '&.Mui-focused fieldset': { borderColor: ERROR_ICON_COLOR },
} as const;

const errorMessageSx = {
  fontFamily: 'Satoshi, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '18px',
  color: 'text.primary',
} as const;

const FieldError = ({
  message,
  detail,
}: {
  message: string;
  detail?: string;
}): React.ReactElement => (
  <Stack
    direction="row"
    spacing={0.75}
    alignItems="flex-start"
    role="alert"
  >
    <OutlinedIcons.OutlinedExclamationCircleIcon
      sx={{ fontSize: 16, color: ERROR_ICON_COLOR, mt: '1px' }}
    />
    <Stack spacing={0.25}>
      <Typography sx={errorMessageSx}>
        {message}
      </Typography>
      {detail && (
        <Typography sx={errorMessageSx}>
          {detail}
        </Typography>
      )}
    </Stack>
  </Stack>
);

export default FieldError;
